import { Button } from "./Button";
import { cx } from "./cx";

export interface PaginationProps {
  page: number;
  pageCount: number;
  onChange: (page: number) => void;
}

/** 首尾页始终可见，中间省略。每页行数由使用方决定（管理后台可选 20、50、100）。 */
export function Pagination({ page, pageCount, onChange }: PaginationProps) {
  const pages = visiblePages(page, pageCount);
  return (
    <nav className="ax-pager" aria-label="分页">
      <Button variant="ghost" size="sm" disabled={page <= 1} onClick={() => onChange(page - 1)}>上一页</Button>
      <div className="ax-pager-pages">
        {pages.map((p, i) =>
          p === "…" ? (
            <span key={`e${i}`} className="ax-pager-page">…</span>
          ) : (
            <button key={p} type="button" className={cx("ax-pager-page", p === page && "is-active")} aria-current={p === page ? "page" : undefined} onClick={() => onChange(p)}>{p}</button>
          ),
        )}
      </div>
      <Button variant="ghost" size="sm" disabled={page >= pageCount} onClick={() => onChange(page + 1)}>下一页</Button>
    </nav>
  );
}

function visiblePages(page: number, count: number): Array<number | "…"> {
  if (count <= 7) return Array.from({ length: count }, (_, i) => i + 1);
  const set = new Set<number>([1, 2, count - 1, count, page - 1, page, page + 1].filter((p) => p >= 1 && p <= count));
  const sorted = [...set].sort((a, b) => a - b);
  const out: Array<number | "…"> = [];
  for (let i = 0; i < sorted.length; i++) {
    if (i > 0 && sorted[i] - sorted[i - 1] > 1) out.push("…");
    out.push(sorted[i]);
  }
  return out;
}
